module.exports = __webpack_public_path__ + "static/media/textPopup.1f51fd1b.svg";